module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"discount":"Desconto"},"en-US":{"discount":"Discount"}}')
  delete Component.options._Ctor
}
